/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  logo,
  baricon,
  baricon1,
  searchnormal,
  noteicon,
  settingicon01,
  noteicon1,
} from "./imagepath";
import config from "../../src/config";
import { toast } from "react-toastify";

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isRegistered, setIsRegistered] = useState(false);
  const [userName, setUserName] = useState("User");
  const [userRole, setUserRole] = useState("User");
  const [profileCompletion, setProfileCompletion] = useState(0);
  const [profileImage, setProfileImage] = useState(null); // State for profile image
  const userUUID = localStorage.getItem("userUUID");

  useEffect(() => {
    const checkBusinessStatus = async () => {
      if (!userUUID) {
        console.log("No userUUID found in localStorage");
        setIsRegistered(false);
        setUserName("User");
        setUserRole("User");
        setProfileCompletion(0);
        setProfileImage(null);
        return;
      }

      try {
        console.log("Checking business status with userUUID:", userUUID);
        const response = await fetch(`${config.API_URL}check_business.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ user_id: userUUID }),
        });

        let data;
        try {
          data = await response.json();
        } catch (e) {
          console.error("Failed to parse API response as JSON:", e.message);
          setIsRegistered(false);
          setUserName("User");
          setUserRole("User");
          setProfileCompletion(0);
          setProfileImage(null);
          return;
        }

        console.log("Check business API response:", { status: response.status, data });

        if (!response.ok) {
          console.error("API returned non-200 status:", response.status);
          setIsRegistered(false);
          setUserName("User");
          setUserRole("User");
          setProfileCompletion(0);
          setProfileImage(null);
          return;
        }

        if (data.error) {
          console.error("API error:", data.error);
          setIsRegistered(false);
          setUserName("User");
          setUserRole("User");
          setProfileCompletion(0);
          setProfileImage(null);
          return;
        }

        setIsRegistered(data.is_registered === true);
        console.log("isRegistered set to:", data.is_registered === true);
      } catch (error) {
        console.error("Error checking business status:", error.message);
        setIsRegistered(false);
        setUserName("User");
        setUserRole("User");
        setProfileCompletion(0);
        setProfileImage(null);
      }
    };

    const fetchUserData = async () => {
      if (!userUUID) {
        console.log("No userUUID for fetching user data");
        setUserName("User");
        setUserRole("User");
        setProfileCompletion(0);
        setProfileImage(null);
        return;
      }

      try {
        console.log("Fetching user data with userUUID:", userUUID);
        const response = await fetch(`${config.API_URL}get_userdata.php?user_id=${userUUID}`);
        const data = await response.json();

        if (data.success === "1" && data.user) {
          const { first_name, last_name, user_id, profile_completion, profile_image } = data.user;
          setUserName(`${first_name} ${last_name}`.trim() || "User");
          setUserRole(user_id || "User");
          setProfileCompletion(profile_completion || 0);
          setProfileImage(profile_image || null); // Set profile image
          console.log("User details fetched:", { first_name, last_name, user_id, profile_completion, profile_image });
        } else {
          console.error("No user data found in response");
          setUserName("User");
          setUserRole("User");
          setProfileCompletion(0);
          setProfileImage(null);
        }
      } catch (error) {
        console.error("Error fetching user data:", error.message);
        setUserName("User");
        setUserRole("User");
        setProfileCompletion(0);
        setProfileImage(null);
      }
    };

    if (userUUID) {
      checkBusinessStatus();
      fetchUserData();
    }

    const interval = setInterval(fetchUserData, 5000);
    return () => clearInterval(interval);
  }, [userUUID]);

  const handlesidebar = () => {
    document.body.classList.toggle("mini-sidebar");
  };

  const handlesidebarmobilemenu = () => {
    document.body.classList.toggle("slide-nav");
    document.getElementsByTagName("html")[0].classList.toggle("menu-opened");
    document.getElementsByClassName("sidebar-overlay")[0].classList.toggle("opened");
  };

  const openDrawer = () => {
    const div = document.querySelector(".main-wrapper");
    if (div?.className?.includes("open-msg-box")) {
      div?.classList?.remove("open-msg-box");
    } else {
      div?.classList?.add("open-msg-box");
    }
  };

  const handleBusinessButtonClick = (e, link) => {
    if (profileCompletion < 100) {
      e.preventDefault();
      toast.error("Please complete your profile");
      navigate("/edit-profile");
    } else {
      navigate(link);
    }
  };

  const buttonText = isRegistered ? "Manage Business" : "Create Business";
  const buttonLink = isRegistered ? "/admin-dashboard" : "/register-business";

  return (
    <div className="main-wrapper">
      <div className="header">
        <div className="header-left">
          <Link to="/admin-dashboard" className="logo">
            <img src={logo} height={40} alt="" />
          </Link>
        </div>
        <Link id="toggle_btn" to="#" onClick={handlesidebar}>
          <img src={baricon} alt="" />
        </Link>
        <Link id="mobile_btn" className="mobile_btn float-start" to="#" onClick={handlesidebarmobilemenu}>
          <img src={baricon1} alt="" />
        </Link>
        <div className="top-nav-search mob-view">
          <form>
            <input
              type="text"
              className="form-control"
              placeholder="Search here"
            />
            <Link className="btn">
              <img src={searchnormal} alt="" />
            </Link>
          </form>
        </div>
        <ul className="nav user-menu d-flex align-items-center float-end">
          {userUUID && (
            <li className="nav-item d-none d-sm-block mx-2">
              <button
                className="btn btn-primary"
                onClick={(e) => handleBusinessButtonClick(e, buttonLink)}
              >
                {buttonText}
              </button>
            </li>
          )}
          {/* <li className="nav-item dropdown d-none d-sm-block mx-2"> */}
            {/* <Link
              to="#"
              className="dropdown-toggle nav-link"
              data-bs-toggle="dropdown"
            >
              <img src={noteicon} alt="" />
              <span className="pulse" />
            </Link> */}
            {/* <div className="dropdown-menu notifications"> */}
              {/* <div className="topnav-dropdown-header">
                <span>Notifications</span>
              </div> */}
              {/* <div className="drop-scroll">
                <ul className="notification-list">
                  <li className="notification-message">
                    <Link to="/user-activity">
                      <div className="media">
                        <span className="avatar">V</span>
                        <div className="media-body">
                          <p className="noti-details">
                            <span className="noti-title">John Doe</span> added
                            new task{" "}
                            <span className="noti-title">
                              Patient appointment booking
                            </span>
                          </p>
                          <p className="noti-time">
                            <span className="notification-time">
                              4 mins ago
                            </span>
                          </p>
                        </div>
                      </div>
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="topnav-dropdown-footer">
                <Link to="/user-activity">View all Notifications</Link>
              </div>
            </div>
          </li> */}
          {/* <li className="nav-item dropdown d-none d-sm-block mx-2">
            <Link
              onClick={openDrawer}
              id="open_msg_box"
              className="hasnotifications nav-link"
            >
              <img src={noteicon1} alt="" />
              <span className="pulse" />
            </Link>
          </li> */}
          <li className="nav-item dropdown has-arrow user-profile-list mx-2">
            <Link
              to="#"
              className="dropdown-toggle nav-link user-link"
              data-bs-toggle="dropdown"
            >
              <div className="user-names">
                <h5>{userName}</h5>
                <span>{userRole}</span>
                {profileCompletion < 100 && (
                  <small className="text-warning">Profile {profileCompletion}% complete</small>
                )}
              </div>
              <span className="user-img">
                <img
                  src={
                    profileImage
                      ? `${config.API_URL}uploads/profile_images/user_images/${profileImage}`
                      : "/favicon.png"
                  }
                  alt="User"
                  style={{
                    width: "40px",
                    height: "40px",
                    objectFit: "cover",
                    borderRadius: "50%",
                  }}
                />
              </span>
            </Link>
            <div className="dropdown-menu">
              <Link className="dropdown-item" to="/profile">
                My Profile
              </Link>
              <Link className="dropdown-item" to="/edit-profile">
                Edit Profile
              </Link>
              <Link className="dropdown-item" to="/logout">
                Logout
              </Link>
            </div>
          </li>
        </ul>
        <div className="dropdown mobile-user-menu float-end">
          <Link
            to="#"
            className="dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="fa-solid fa-ellipsis-vertical" />
          </Link>
          <div className="dropdown-menu dropdown-menu-end">
            <div className="user-info">
              <h6>{userName}</h6>
              <small>{userRole}</small>
              {profileCompletion < 100 && (
                <small className="text-warning">Profile {profileCompletion}% complete</small>
              )}
            </div>
            <div className="dropdown-divider"></div>
            <Link className="dropdown-item" to="/profile">
              My Profile
            </Link>
            <Link className="dropdown-item" to="/edit-profile">
              Edit Profile
            </Link>
            <Link className="dropdown-item" to="/logout">
              Logout
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;